import { isFeatureEnabled } from './util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
const VALID_STATUSES = [
    'Linked to Final Invoice',
    'Linked to Supplier Invoice',
    'Linked to Partial Supplier Invoice',
];
export const isNftpRoeEnabled = (isNftpBillable: boolean = false, featureToggles: any) => {
    return isNftpBillable && isFeatureEnabled(FEATURE_TOGGLES.FINOPS_NFTP_ROE, featureToggles);
}

export const calculateActualTotal = (rateDetailsList: any[], itemCategory: string) => {
    return rateDetailsList
        .filter((item: any) => item.itemCategory === itemCategory && VALID_STATUSES.includes(item.status))
        .reduce((total: number, item: any) => {
            return total + Number(((Number(item.invoiceAmount) + Number(item.invoiceTaxAmount)) * Number(item.invoiceROE)).toFixed(2));
        }, 0)
        .toFixed(2);
};

export const remapExportCostAndRevenueData = (response: any) => {
    const responseCopy = JSON.parse(JSON.stringify(response));
    responseCopy?.result[0]?.essoRateDetailsModels?.forEach((item:any) => {
        item.invoiceAmount = VALID_STATUSES.includes(item.status) ? item.invoiceAmount : '-';
        item.invoiceTaxAmount = VALID_STATUSES.includes(item.status) ? item.invoiceTaxAmount : '-';
        item.invoiceROE = VALID_STATUSES.includes(item.status) ? item.invoiceROE : '-';
        item.invoiceCurrency = VALID_STATUSES.includes(item.status) ? item.invoiceCurrency : '-';
        item.invoiceNumber = VALID_STATUSES.includes(item.status) ? item.invoiceNumber : '-';
    });
    return responseCopy;
};

export const remapImportCostAndRevenueData = (response: any) => {
    const responseCopy = JSON.parse(JSON.stringify(response));
    responseCopy?.result[0]?.issoChargeLines?.forEach((item:any) => {
        item.invoiceAmount = VALID_STATUSES.includes(item.status) ? item.invoiceAmount : '-';
        item.invoiceTaxAmount = VALID_STATUSES.includes(item.status) ? item.invoiceTaxAmount : '-';
        item.invoiceROE = VALID_STATUSES.includes(item.status) ? item.invoiceROE : '-';
        item.invoiceCurrency = VALID_STATUSES.includes(item.status) ? item.invoiceCurrency : '-';
        item.invoiceNumber = VALID_STATUSES.includes(item.status) ? item.invoiceNumber : '-';
    });
    return responseCopy;
};

export const remapCostAndRevenueData = (response: any) => {
    const responseCopy = JSON.parse(JSON.stringify(response));
    responseCopy?.data?.forEach((item:any) => {
        item.invoiceAmount = VALID_STATUSES.includes(item.status) ? item.invoiceAmount : '-';
        item.invoiceTaxAmount = VALID_STATUSES.includes(item.status) ? item.invoiceTaxAmount : '-';
        item.invoiceROE = VALID_STATUSES.includes(item.status) ? item.invoiceROE : '-';
        item.invoiceCurrency = VALID_STATUSES.includes(item.status) ? item.invoiceCurrency : '-';
        item.invoiceNumber = VALID_STATUSES.includes(item.status) ? item.invoiceNumber : '-';
    });
    return responseCopy;
};